<template lang="pug">
  .contact-confirm-switch(@click.stop="onSwitch()")
    input(type="checkbox" v-model="switchValue")
    label.switch-label()
        span
    .switch-img
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

/**
 * ON/OFFを切り替えるスイッチコンポーネント
 */
@Component
export default class ContactConfirmSwitch extends Vue {
  /**
   * 親コンポーネントから受け取るスイッチの値
   */
  @Prop({
    default: () => {
      return false;
    }
  })
  private value!: boolean;

  /**
   * 本コンポーネントのチェックボックスに紐づくスイッチの値
   */
  private switchValue: boolean = false;

  /**
   * 親コンポーネントから渡された値に変更があった場合、スイッチの値を同期する
   */
  @Watch("value")
  private changeSwitchValue(newValue: boolean): void {
    this.switchValue = newValue;

    return;
  }

  /**
   * vue lifecycle created
   *
   * 親コンポーネントから渡されてきた値でスイッチの値を初期化する
   */
  private created(): void {
    this.switchValue = this.value;

    return;
  }

  /**
   * スイッチ切り替え時イベント
   */
  private onSwitch(): void {
    this.$emit("onSwitch", this.switchValue);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";

// ボタン領域
.contact-confirm-switch {
  line-height: 26px;
  letter-spacing: 0;
  text-align: center;
  position: relative;
  width: 68px;

  // チェックボックス
  input[type="checkbox"] {
    display: none;
  }

  // リンクであることが分かるようにカーソルを変える
  cursor: pointer;

  // ラベル
  label.switch-label {
    display: block;
    box-sizing: border-box;
    height: 28px;
    border: 2px solid $errormessage-font-color;
    border-radius: 4px;
    font-size: 11px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 0;
    // リンクであることが分かるようにカーソルを変える
    cursor: pointer;
  }

  // ラベル(ON)
  input[type="checkbox"]:checked + label {
    // ON時の枠線
    border-color: $switch-bordercolor;
  }

  // 表示する文字(OFF)
  label span:after {
    content: "未確認";
    padding: 0 0 0 20px;
    color: $errormessage-font-color;
  }

  // 表示する文字(ON)
  input[type="checkbox"]:checked + label span:after {
    content: "確認済";
    padding: 0 20px 0 0;
    color: $switch-bordercolor;
  }

  // トグル部分
  .switch-img {
    position: absolute;
    width: 20px;
    height: 20px;
    background: $errormessage-font-color;
    top: 4px;
    left: 4px;
    border-radius: 2px;
    transition: 0.2s;
  }

  // トグル部分(ON)
  input[type="checkbox"]:checked ~ .switch-img {
    transform: translateX(40px);
    background: $switch-bordercolor;
  }
}
</style>
